import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import { THEME_BOLD } from '@/constants/constants'
import { SeoBlock } from '../SeoBlock'
import { SeoPlaceholderBlock } from '../SeoPlaceholderBlock'

export type SeoBlockType =
  | 'title'
  | 'description'
  | 'slug'
  | 'keywords'
  | 'page_intent'

interface Props {
  value?: string
  hideDivider: boolean
  placeholder: string
  type: SeoBlockType
}

export const SeoBlockOrPlaceholder: React.FC<Props> = ({
  value,
  hideDivider,
  placeholder,
  type,
}) => {
  const theme = useSelector(migrationProjectSelector.getProjectTheme)
  const themeBold = theme === THEME_BOLD

  if (!value) {
    return (
      <SeoPlaceholderBlock
        placeholder={placeholder}
        hideDivider={hideDivider}
        themeBold={themeBold}
      />
    )
  }

  return <SeoBlock text={value} type={type} themeBold={themeBold} />
}
